module.exports = __webpack_public_path__ + "static/media/FatimaRiveria.08a373d3.jpg";